import React from "react"
import PropTypes from "prop-types"
import { useCmsIntegration } from "@modules/cms/shared/hooks/useCmsIntegration"
import { SiteSettingsSection } from "../constants"
import { CmsIntegrationCard } from "@modules/cms/integration/components/CmsIntegrationCard"
import { CmsManualIntegration } from "@modules/cms/integration/components/CmsManualIntegration"
import { useFlags } from "@modules/featureFlags"

function CmsIntegrations({ siteId, orgSiteName, permissionToEdit }) {
  const { flags } = useFlags()
  const cmsIntegrations = useCmsIntegration(siteId)
  const manualCmsIntegrations = useCmsIntegration()

  return (
    <React.Fragment>
      <CmsIntegrationCard
        integrationsBlockId={SiteSettingsSection.DataSource}
        siteId={siteId}
        title={
          flags.dataLayerFlag ? "Data Sources" : "Data Source Integrations"
        }
        docUrl={flags.dataLayerFlag ? null : "/docs/integration-guide"}
        orgSiteName={orgSiteName}
        permissionToEdit={permissionToEdit}
        {...cmsIntegrations}
      >
        <CmsManualIntegration
          integrationsBlockId={SiteSettingsSection.ManualIntegrations}
          siteId={siteId}
          docUrl="/docs/#getting-started-with-gatsby-preview-and-your-cms"
          {...manualCmsIntegrations}
        />
      </CmsIntegrationCard>
    </React.Fragment>
  )
}

CmsIntegrations.propTypes = {
  siteId: PropTypes.string.isRequired,
  orgSiteName: PropTypes.string,
  permissionToEdit: PropTypes.bool,
}

export default CmsIntegrations
